import yieldIcon from "../assets/yield.png";
import dalalIcon from "../assets/dalal.png";
import carnivalIcon from "../assets/carnival.png";

export default function Ventures() {
  return (
    <section id="ventures" className="bg-white py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* ================= TITLE ================= */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
            Our <span className="text-primary">Ventures</span>
          </h2>

          <p className="mt-3 sm:mt-4 text-sm sm:text-base text-gray-500 max-w-2xl mx-auto">
            A portfolio of brands focused on innovation, transparency, and long-term
            value creation in capital markets.
          </p>
        </div>

        {/* ================= GRID ================= */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-10">

          {/* ================= CARD ================= */}
          {[
            {
              link: "https://yield.support/",
              icon: yieldIcon,
              title: "YIELD",
              content: [
                "Yield is India’s first wealth ecosystem built on a foundation of radical alignment. We have solved the industry’s biggest flaw: the conflict of interest. Unlike traditional firms that hand you over to sales-driven Relationship Managers, we map your account directly to SEBI Registered Research Analysts (RAs).",
                "​We have abolished sales incentives—our team will never mis-sell you a product you don't need. Instead, we flipped the model: our RAs earn incentives only when they outperform your portfolio benchmarks. If you don't generate alpha, we don't get rewarded. At Yield, 'Fair to the Client' isn't just a policy; it is the non-negotiable engine of our business."
              ],
            },
            {
              link: "https://dalalstreetofindia.com",
              icon: dalalIcon,
              title: "DALAL STREET OF INDIA",
              content: [
                "In a market defined by noise, we are the signal. Dalal Street of India is the premier digital pulse of the capital markets, upgraded with a proprietary AI engine that transforms general news into personal intelligence.",
                "We don’t just report headlines; our system continuously scans thousands of data points to deliver real-time risk alerts and opportunities specifically mapped to your holding stocks.",
                " Whether it’s a regulatory shift or a quarterly result, if it impacts your portfolio, you know instantly. We decode the data so you don’t just see the market—you understand your position in it."
              ],
            },
            {
              link: "https://financialcarnival.com",
              icon: carnivalIcon,
              title: "FINANCIAL CARNIVAL",
              content: [
                "True financial freedom shouldn't be a luxury of the metros; it is a right of every Indian. Financial Carnival is a grassroots movement engineered to unlock the sleeping wealth of Bharat. We bypass saturated Tier-1 hubs to focus on the real revolution—Tier 3 and 4 cities, which now drive nearly 50% of all new mutual fund folios.",
                "​With rural internet penetration hitting 56% by 2025, the gap isn't connectivity—it's confidence. We bridge that gap through vernacular education, localized events, and community trust. We are converting millions of savers into investors, building the on-ramp for India’s next economic powerhouse."
              ],
            },
          ].map((card, i) => (
            <a
              key={i}
              href={card.link}
              target="_blank"
              rel="noopener noreferrer"
              className="
                group block bg-white rounded-2xl
                border border-gray-100
                p-5 sm:p-6 md:p-7 lg:p-8
                transition-all duration-300
                hover:shadow-xl hover:-translate-y-1
                active:scale-[0.99]
              "
            >
              {/* ICON + TITLE */}
              <div className="flex items-center gap-3 sm:gap-4 mb-4">
                <img
                  src={card.icon}
                  alt={card.title}
                  className="
                    h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24
                    object-contain rounded-xl border border-gray-200 p-[-70px] bg-white
                    transition-transform duration-300 group-hover:scale-105
                  "
                />

                <h3
                  className="
                    text-sm sm:text-base md:text-lg
                    font-bold text-gray-900
                    leading-tight
                    break-words
                  "
                >
                  {card.title}
                </h3>
              </div>

              {/* TEXT */}
              <div className="space-y-3">
                {card.content.map((para, idx) => (
                  <p
                    key={idx}
                    className="
                      text-xs sm:text-[15px]
                      text-gray-600
                      leading-relaxed
                      text-justify
                    "
                  >
                    {para}
                  </p>
                ))}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
